'use strict';

export class NodeType {
  static Revision = 'Revision';
  static Chapter = 'Chapter';
  static Information = 'Information';
  static Standard = 'Standard';
  static Bullet = 'Bullet'; 
}
